import React from 'react';
import { Modal, Typography } from 'antd';
import AntDButton from '../Button';
import { ISharedConfirmModalProps } from 'src/models/ConfirmModal';

const { Title, Paragraph } = Typography;

const SharedConfirmModal: React.FC<ISharedConfirmModalProps> = ({
  show,
  onCancel,
  onConfirm,
  title,
  description,
  footer,
  style,
}) => {
  return (
    <Modal
      open={show}
      onCancel={onCancel}
      onOk={onConfirm}
      centered
      maskClosable={false}
      title={
        <Title level={4} style={{ margin: 0, padding: '1rem' }}>
          {title}
        </Title>
      }
      footer={
        <div style={{ padding: '1rem', textAlign: 'right' }}>
          <AntDButton
            type="primary"
            onClick={onConfirm}
            statusOnComplete="Confirm"
            style={style}
            htmlType="button"
          />
        </div>
      }
      width={400}
    >
      {description && (
        <Paragraph
          style={{ marginBottom: 0, color: 'black', padding: '0 1rem' }}
        >
          {description}
        </Paragraph>
      )}
    </Modal>
  );
};

export default SharedConfirmModal;
